import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';

import images from "../../assets/img/images";


const styles = {
    container: {
        width: 380,
        height: 250
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
    },
    warning: {
        right: -180,
        top: 80,
        color: "red"
    },
    warningMessage: {
        top: 100,
        left: 35,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    buttons: {
        display: "table",
        margin: "0 auto",
        left: 30,
        top: 152
    }
};

const EditWarning = withStyles(styles)((props) => {
    const {
        classes,
        handleClose,
        handleRowClick,
        handleNo,
        message,
        warningType
    } = props;

    return (
        <div className={classes.container}>
            <div className={classes.close}>
                <CloseIcon closeFunction={handleClose} />
            </div>
            <div style={{ height: 0 }}>
                <img src={warningType === "delete" ? images.deleteWarningTriangle : images.warningTriangleOrange} className={classes.warning} alt="warning"></img><br />
                <span className={classes.warningMessage}>{I18n.get(message)}</span>
            </div>
            <div className={classes.buttons}>
                <Button onClick={() => { handleNo()}} color="primary">
                    {I18n.get("site_no")}
                </Button>
                <Button onClick={() => { handleRowClick() }} style={{ top: "-4px", left: "14px", backgroundColor: warningType === "delete" ? "red" : ""}} variant="contained" color="primary">
                    {I18n.get("site_yes")}
                </Button>
            </div>


        </div>
    );

});

export default withRouter(EditWarning);
